<div *ngIf="!isReportingTemplate">
  <div class="card">
    <div class="card-header text-header">
      <div> Rule Library</div>
    </div>
    <app-progress-bar [isLoading]="isLoadingMain"></app-progress-bar>
    <div class="p-2">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link" *ngIf="checkRoutePermission('/library/rulebook-dashboard')" id="nav-dashboard-tab"
            (click)="getTabText('Rulebook Dashboard')" [routerLink]="['/library/rulebook-dashboard/']"
            [routerLinkActive]="['active']">
            Dashboard
          </a>
          <a class="nav-item nav-link" *ngIf="checkRoutePermission('/library/rule-hierarchy')" id="nav-rule-hierarchy-tab"
            (click)="getTabText('Rule Hierarchy')" [routerLink]="['/library/rule-hierarchy/']"
            [routerLinkActive]="['active']"><i *ngIf="gdprService.isShowRuleTree" class="fa fa-circle-o-notch fa-spin"
              style="font-size: .875rem; line-height: 1.5;"></i>
            Rule Hierarchy
          </a>
          <a class="nav-item nav-link" id="nav-rule-tree-tab" *ngIf="checkRoutePermission('/library/rule-tree')"
            (click)="getTabText('Rule Tree')" [routerLink]="['/library/rule-tree/']" [routerLinkActive]="['active']"><i
              *ngIf="gdprService.isShowRuleTree" class="fa fa-circle-o-notch fa-spin"
              style="font-size: .875rem; line-height: 1.5;"></i>
            Rule Tree
          </a>
          <a class="nav-item nav-link" id="nav-library-tab" (click)="getTabText('Rulebook')"
            [routerLink]="[ sessionService.rulebookUrl + '/']" [routerLinkActive]="['active']">Rulebook <span
              *ngIf="sessionService.newRulebookCount > 0">({{sessionService.newRulebookCount}})</span></a>
          <a class="nav-item nav-link" id="nav-open-linked-updates-tab" (click)="getTabText('Open Linked Updates')"
            *ngIf="checkRoutePermission('/library/open-linked-updates')" [routerLink]="['/library/open-linked-updates/']"
            [routerLinkActive]="['active']">Open Linked Updates <span
              *ngIf="sessionService.openLinkedUpdates > 0">({{sessionService.openLinkedUpdates}})</span></a>
          <a class="nav-item nav-link" id="nav-actioned-linked-updates-tab"
            (click)="getTabText('Actioned Linked Updates')"
            *ngIf="checkRoutePermission('/library/actioned-linked-updates')"
            [routerLink]="['/library/actioned-linked-updates/']" [routerLinkActive]="['active']">Actioned Linked
            Updates <span
              *ngIf="sessionService.actionedLinkedUpdates > 0">({{sessionService.actionedLinkedUpdates}})</span></a>
          
        </div>
      </nav>
      <div class="card-body">
        <div class="tab-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- For Report template -->
<div *ngIf="isReportingTemplate">
  <router-outlet></router-outlet>
</div>

